'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = flattenMessages;
function flattenMessages(nestedMessages) {
    var prefix = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];

    return Object.keys(nestedMessages).reduce(function (messages, key) {
        var value = nestedMessages[key];
        var prefixedKey = prefix ? prefix + '.' + key : key;

        if (typeof value === 'string') {
            messages[prefixedKey] = value;
        } else {
            Object.assign(messages, flattenMessages(value, prefixedKey));
        }

        return messages;
    }, {});
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/flatten-messages.js
 ** module id = 661
 ** module chunks = 0
 **/